/**
 * Agent hotel search list/map — raw `LowestPackagePrice` from /searchHotels (or composite merged row).
 * No FX, commission, or rounding beyond display grouping.
 */

import {
  formatHotelSearchAmountForDisplay,
  getHotelSearchCurrencyMeta,
} from "../constants/hotelCurrencies";

/**
 * @param {object|null|undefined} hotelItem
 * @returns {number|null} positive finite API value or null
 */
export function agentHotelSearchLowestPackagePrice(hotelItem) {
  const lp = Number(hotelItem?.LowestPackagePrice);
  if (!Number.isFinite(lp) || lp <= 0) return null;
  return lp;
}

/**
 * For filter/slider upper bound; falls back to lowest when highest missing.
 * @param {object|null|undefined} hotelItem
 * @returns {number|null}
 */
export function agentHotelSearchHighestPackagePrice(hotelItem) {
  const hp = Number(hotelItem?.HighestPackagePrice);
  if (Number.isFinite(hp) && hp > 0) return hp;
  return agentHotelSearchLowestPackagePrice(hotelItem);
}

/**
 * @param {number|null|undefined} value
 * @param {string|null|undefined} [currencyCode] — ISO code; symbol from `hotelCurrencies` (no FX)
 * @returns {string|null}
 */
export function formatAgentHotelSearchApiPriceDisplay(value, currencyCode) {
  if (value == null || !Number.isFinite(Number(value))) return null;
  return (
    formatHotelSearchAmountForDisplay(Number(value), currencyCode) ??
    (() => {
      const { symbol } = getHotelSearchCurrencyMeta(currencyCode);
      return `${symbol}${String(Math.floor(Number(value)))}`;
    })()
  );
}
